import styles from './WelcomeBack.module.scss';

interface WelcomeBackData {
  message?: string;
}

interface WelcomeBackProps {
  data?: WelcomeBackData | WelcomeBackData[];
}

function firstPayload(payload?: WelcomeBackData | WelcomeBackData[]) {
  return Array.isArray(payload) ? payload[0] : payload;
}

export default function WelcomeBack({ data }: WelcomeBackProps) {
  const actualData = firstPayload(data);
  const text = actualData?.message ?? '';

  if (!text) {
    return null;
  }

  return (
    <div className={styles.welcomeBack} id="welcome-back-message">
      <p className={styles.message}>{text}</p>
    </div>
  );
}
